export /**
 * 公里与英里转换工具
 * 转换系数：1公里 = 0.621371英里；1英里 = 1.60934公里
 */
const DistanceConverter = {
  // 公里转英里
  kmToMiles: function (km) {
    // 验证输入是否为有效数字
    if (typeof km !== "number" || isNaN(km)) {
      throw new Error("请输入有效的公里数");
    }
    return this.formatResult(km * 0.621371);
  },

  // 英里转公里
  milesToKm: function (miles) {
    // 验证输入是否为有效数字
    if (typeof miles !== "number" || isNaN(miles)) {
      throw new Error("请输入有效的英里数");
    }
    return this.formatResult(miles * 1.60934);
  },

  // 格式化转换结果（保留n位小数）
  formatResult: function (value, decimalPlaces = 2) {
    return parseFloat(value.toFixed(decimalPlaces));
  },
};
